import { TFunction } from 'i18next';
import { isLiftTicketPackageProduct, isLiftTicketProduct } from 'common/modules/skidata';
import { ProductApi } from 'common/types';
import { TagProps } from 'components/Tag';
import {
	isProductForSale,
	isPackageProduct,
	isProductVisibleInMultipleLocations,
	isProductForRent,
} from 'common/modules/products/utils';

export const getProductTags = (
	product: ProductApi | null | undefined,
	shopLocationCount: number,
	t: TFunction,
): TagProps[] => {
	const tags: TagProps[] = [];

	if (!product) return [];

	const isPackageLiftTicket = isLiftTicketPackageProduct(product);
	const isRegularLiftTicket = isLiftTicketProduct(product);
	const isLiftTicket = isPackageLiftTicket || isRegularLiftTicket;

	if (isPackageLiftTicket) {
		tags.push({
			text: t('product.ticketPackage', 'Ticket package'),
			color: 'primary',
		});
	} else if (isRegularLiftTicket) {
		tags.push({
			text: t('product.ticketProduct', 'Ticket product'),
			color: 'primary',
		});
	} else if (isPackageProduct(product)) {
		tags.push({
			text: t('product.package', 'Package'),
			color: 'primary',
		});
	}

	if (isProductForRent(product) && !isLiftTicket) {
		tags.push({
			text: t('product.forRent', 'For rent'),
			color: 'primary',
		});
	}

	if (isProductForSale(product) || isLiftTicket) {
		tags.push({
			text: t('product.forSale', 'For sale'),
			color: 'primary',
		});
	}

	if (isProductVisibleInMultipleLocations(product, shopLocationCount)) {
		tags.push({
			text: t('product.shared', 'Shared'),
			tooltip: t('product.sharedDescription', 'Shared products are visible in more than one store'),
			color: 'primary',
		});
	}

	return tags;
};
